import { render, staticRenderFns } from "./ResidentImport.vue?vue&type=template&id=6d000fc1&scoped=true&"
import script from "./ResidentImport.vue?vue&type=script&lang=js&"
export * from "./ResidentImport.vue?vue&type=script&lang=js&"
import style0 from "./ResidentImport.vue?vue&type=style&index=0&id=6d000fc1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d000fc1",
  null
  
)

export default component.exports